import {AdSize} from '../adSize.types';

export default function formatAdSizeToString(adSize: AdSize) {
  if (!adSize) return 'All';

  return adSize.width === 0 ? 'All' : `${adSize.width}x${adSize.height}`;
}
